import src from "IMAGE";
export default { src, width: 420, height: 340, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
